module.exports = __webpack_public_path__ + "static/media/community_guideline_zh-TW_HK.14e5c78a.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/community_guideline_zh-TW_HK.md
// module id = 47
// module chunks = 0